import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-f1f6b448"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "menu-container"
  }, null, -1);
});

var _hoisted_2 = {
  id: "menu-mobile"
};
var _hoisted_3 = {
  class: "d-flex p-0 m-0"
};
var _hoisted_4 = {
  id: "btn-upload-hd",
  title: "upload HD"
};
var _hoisted_5 = {
  id: "btn-split-view",
  title: "Split view to compare products"
};
var _hoisted_6 = {
  id: "btn-select-floor",
  title: "select floor"
};
var _hoisted_7 = {
  id: "btn-select-wall",
  title: "select wall"
};
var _hoisted_8 = {
  id: "btn-zoom",
  title: "Zoom"
};
var _hoisted_9 = {
  id: "btn-share",
  title: "Partager l'image"
};
var _hoisted_10 = {
  id: "btn-print",
  title: "Imprimer l'image"
};
var _hoisted_11 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_UploadSVG = _resolveComponent("UploadSVG");

  var _component_CompareSVG = _resolveComponent("CompareSVG");

  var _component_FloorSVG = _resolveComponent("FloorSVG");

  var _component_WallSVG = _resolveComponent("WallSVG");

  var _component_ZoomSVG = _resolveComponent("ZoomSVG");

  var _component_ShareSVG = _resolveComponent("ShareSVG");

  var _component_ShareModal = _resolveComponent("ShareModal");

  var _component_PrintSVG = _resolveComponent("PrintSVG");

  var _component_DownloadSVG = _resolveComponent("DownloadSVG");

  return _openBlock(), _createElementBlock(_Fragment, null, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("ul", _hoisted_3, [_createElementVNode("li", {
    onClick: _cache[0] || (_cache[0] = //@ts-ignore
    function () {
      return _ctx.openModalEspace && _ctx.openModalEspace.apply(_ctx, arguments);
    })
  }, [_createElementVNode("a", _hoisted_4, [_createVNode(_component_UploadSVG, {
    fill: _ctx.myColor,
    style: {
      "align-self": "center"
    }
  }, null, 8, ["fill"])])]), _createElementVNode("li", {
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.handleCompare({
        toggle: true
      });
    })
  }, [_createElementVNode("a", _hoisted_5, [_createVNode(_component_CompareSVG, {
    fill: _ctx.myColor,
    style: {
      "align-self": "center"
    }
  }, null, 8, ["fill"])])]), _createElementVNode("li", {
    onClick: _cache[2] || (_cache[2] = //@ts-ignore
    function () {
      return _ctx.openModalFloor && _ctx.openModalFloor.apply(_ctx, arguments);
    })
  }, [_createElementVNode("a", _hoisted_6, [_createVNode(_component_FloorSVG, {
    fill: _ctx.myColor,
    style: {
      "align-self": "center"
    }
  }, null, 8, ["fill"])])]), _createElementVNode("li", {
    onClick: _cache[3] || (_cache[3] = //@ts-ignore
    function () {
      return _ctx.openModalWall && _ctx.openModalWall.apply(_ctx, arguments);
    })
  }, [_createElementVNode("a", _hoisted_7, [_createVNode(_component_WallSVG, {
    fill: _ctx.myColor,
    style: {
      "align-self": "center"
    }
  }, null, 8, ["fill"])])]), _createElementVNode("li", {
    onClick: _cache[4] || (_cache[4] = //@ts-ignore
    function () {
      return _ctx.handleZoom && _ctx.handleZoom.apply(_ctx, arguments);
    })
  }, [_createElementVNode("a", _hoisted_8, [_createVNode(_component_ZoomSVG, {
    fill: _ctx.myColor,
    style: {
      "align-self": "center"
    }
  }, null, 8, ["fill"])])]), _createVNode(_component_ShareModal, null, {
    default: _withCtx(function () {
      return [_createElementVNode("li", null, [_createElementVNode("a", _hoisted_9, [_createVNode(_component_ShareSVG, {
        fill: _ctx.myColor,
        style: {
          "align-self": "center"
        }
      }, null, 8, ["fill"])])])];
    }),
    _: 1
  }), _createElementVNode("li", {
    onClick: _cache[5] || (_cache[5] = //@ts-ignore
    function () {
      return _ctx.printImage && _ctx.printImage.apply(_ctx, arguments);
    })
  }, [_createElementVNode("a", _hoisted_10, [_createVNode(_component_PrintSVG, {
    fill: _ctx.myColor,
    style: {
      "align-self": "center"
    }
  }, null, 8, ["fill"])])]), _createElementVNode("li", null, [_createElementVNode("a", {
    href: _ctx.sharingURL,
    id: "btn-download",
    title: "Télecharger l'image",
    target: "_blank",
    download: "result.jpeg"
  }, [_createVNode(_component_DownloadSVG, {
    fill: _ctx.myColor,
    style: {
      "align-self": "center"
    }
  }, null, 8, ["fill"])], 8, _hoisted_11)])])])], 64);
}